"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "var(--sds--ursa-icons--background-color, transparent)",
  d: "M3.35 6.971c0-.845.685-1.171 1.53-1.171h3.57v2.8H4.88c-.845 0-1.53-.784-1.53-1.629m2.46 6.072c0-.833.676-1.643 1.509-1.643H8.44v2.8H7.319c-.833 0-1.509-.324-1.509-1.157m8.202-6.057c0-.827-.67-1.186-1.497-1.186h-.935v2.8h.935c.826 0 1.497-.787 1.497-1.614m2.87 6.034c0-.838-.68-1.62-1.517-1.62H11.58v2.8h3.785c.838 0 1.517-.342 1.517-1.18"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M15.3 12.1a.3.3 0 0 1 .3.3v.8a.3.3 0 0 1-.3.3h-3.05a.7.7 0 1 0 0 1.4h3.05a1.7 1.7 0 0 0 1.7-1.7v-.8a1.7 1.7 0 0 0-1.7-1.7h-3.05a.7.7 0 1 0 0 1.4zm-6.85-.7a.7.7 0 0 0-.7-.7h-.6a1.7 1.7 0 0 0-1.7 1.7v.8a1.7 1.7 0 0 0 1.7 1.7h.6a.7.7 0 1 0 0-1.4h-.6a.3.3 0 0 1-.3-.3v-.8a.3.3 0 0 1 .3-.3h.6a.7.7 0 0 0 .7-.7m4.4-4.9a.3.3 0 0 1 .3.3v.8a.3.3 0 0 1-.3.3h-.6a.7.7 0 1 0 0 1.4h.6a1.7 1.7 0 0 0 1.7-1.7v-.8a1.7 1.7 0 0 0-1.7-1.7h-.6a.7.7 0 1 0 0 1.4zm-4.4-.7a.7.7 0 0 0-.7-.7H4.7A1.7 1.7 0 0 0 3 6.8v.8a1.7 1.7 0 0 0 1.7 1.7h3.05a.7.7 0 1 0 0-1.4H4.7a.3.3 0 0 1-.3-.3v-.8a.3.3 0 0 1 .3-.3h3.05a.7.7 0 0 0 .7-.7M10 3a.7.7 0 0 0-.7.7v12.6a.7.7 0 0 0 1.4 0V3.7A.7.7 0 0 0 10 3",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=TimelineIcon20.js.map